import { Badge, Hidden, IconMinus, IconTick, Text } from 'braid-design-system';

import type {
  JobAdFeatureChartSiteConfig,
  JobAdPlanDataItem,
} from './chartData';
import { TableCellBox, TableRow } from './components/TableUI';

const renderDataItem = (item: JobAdPlanDataItem, embed?: boolean) => {
  if (item.type === 'badge') {
    return <Badge weight={embed ? 'strong' : 'regular'}>{item.info}</Badge>;
  }

  if (item.type === 'icon') {
    switch (item.info) {
      case 'no':
        return <IconMinus tone="secondary" />;
      case 'yes':
        return <IconTick tone="brandAccent" />;
      case 'optional':
        return (
          <ResponsiveText
            size={{ mobile: 'xsmall', desktop: 'small' }}
            tone="secondary"
          >
            Optional
          </ResponsiveText>
        );
      default:
        return null;
    }
  }

  return null;
};

export const JobAdPlanInfo = ({
  embed,
  data,
}: {
  embed?: boolean;
  data: JobAdFeatureChartSiteConfig;
}) =>
  data.jobAdPlanInfo.map((item) => (
    <TableRow embed={embed} key={item.title} colNum={data.colNum}>
      <TableCellBox align="left" embed={embed}>
        <ResponsiveText size={{ mobile: 'xsmall', desktop: 'small' }}>
          {item.title}
        </ResponsiveText>
      </TableCellBox>
      {item.data.map((d, i) => (
        <TableCellBox embed={embed} key={`${item.title}-${i}`}>
          {renderDataItem(d, embed)}
        </TableCellBox>
      ))}
    </TableRow>
  ));

const ResponsiveText = ({
  size,
  children,
  tone,
}: {
  size: {
    mobile: React.ComponentProps<typeof Text>['size'];
    desktop: React.ComponentProps<typeof Text>['size'];
  };
  tone?: React.ComponentProps<typeof Text>['tone'];
  children: string;
}) => (
  <>
    <Hidden below="desktop">
      <Text size={size.desktop} align="left" tone={tone ?? 'neutral'}>
        {children}
      </Text>
    </Hidden>
    <Hidden above="tablet">
      <Text size={size.mobile} align="left" tone={tone ?? 'neutral'}>
        {children}
      </Text>
    </Hidden>
  </>
);
